
import { currentOrigin } from '@/utils/location'
import { LOGIN_PATH, LOGIN_CLIENT_ID, LOGIN_CLIENT_SECRET } from './env'




const getRandomStr = (length) => {
  var str = Math.random().toString(36).substr(2);
  if (str.length >= length) {
    return str.substr(0, length);
  }
  str += getRandomStr(length - str.length);
  return str;
}

// // // 统一登录client_id
// export const LOGIN_CLIENT_ID = 'process-designer'

// // // 统一登录授权密码
// export const LOGIN_CLIENT_SECRET = 'ido85R&Process'

// 统一登录地址+参数
export const loginUri = `${LOGIN_PATH}/oauth/authorize?client_id=${LOGIN_CLIENT_ID}&redirect_uri=${currentOrigin}&response_type=code&state=${getRandomStr(6)}`

// 统一登录获取token授权类型
export const LOGIN_GRANT_TYPE = 'authorization_code'

// 统一登录Authorization
export const AUTHORIZATION = window.btoa(`${LOGIN_CLIENT_ID}:${LOGIN_CLIENT_SECRET}`)


// 当前项目名称
export const PROJECT_NAME = '一企一册'

// 第一个页面的面包屑名称
export const DEFAULT_PAGE_NAME = '企业列表'

// 这些参数是配置的
// 为false则不显示
export const SHOW_MENU_FIELD = 'isShow'
